module.exports = __webpack_public_path__ + "img/Avancar.1ea6cbfb.png";